import React, { ReactNode } from 'react'
import { TouchableOpacity, View } from 'react-native'
import { round } from 'lodash'
import { Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'

export interface ProductOptionProps {
  tag?: string
  onPress: () => void
  selected: boolean
  pricePerMonth: number
  interval: string
  breakdownText: string | ReactNode
}

export const ProductOption = ({
  interval,
  pricePerMonth,
  tag,
  onPress,
  selected,
  breakdownText,
}: ProductOptionProps) => {
  const styles = useStyleSheet(themedStyle)

  return (
    <TouchableOpacity
      accessibilityLabel="Select Plan"
      onPress={onPress}
      style={[styles.container, selected && styles.selected]}
    >
      {!!tag && (
        <View style={styles.tag}>
          <Text type="tiny" style={{ color: 'white' }} bold>
            {tag}
          </Text>
        </View>
      )}
      <Text type="small" bold style={styles.interval}>
        {interval.toUpperCase()}
      </Text>
      <Text type="regular" bold>
        ${round(pricePerMonth, 2)}/month
      </Text>
      <Text type="tiny" style={styles.breakdown}>
        Billed {interval}
        {'\n'}
        {breakdownText}
      </Text>
    </TouchableOpacity>
  )
}

const themedStyle = StyleService.create({
  container: {
    justifyContent: 'space-between',
    padding: 12,
    alignItems: 'center',
    borderWidth: 2,
    borderColor: 'theme.surface.base1',
    maxWidth: 176,
    flex: 1,
    backgroundColor: 'theme.background',
    borderRadius: 24,
    gap: 6,
  },
  tag: {
    alignItems: 'center',
    backgroundColor: 'theme.primary.base',
    borderRadius: 48,
    paddingHorizontal: 8,
    height: 24,
    position: 'absolute',
    justifyContent: 'center',
    top: -12,
  },
  selected: {
    borderColor: 'theme.primary.base',
    backgroundColor: 'theme.surface.base2',
  },
  interval: {
    marginTop: 10,
    color: 'theme.text.secondary',
  },
  breakdown: {
    textAlign: 'center',
  },
})
